module.exports = __webpack_public_path__ + "static/media/sign-out-alt.1034484c.svg";